import { useEffect } from 'react';
import { Table } from 'antd';

import { useErrorsListColumns } from './useErrorsListColumns';

export const ErrorList = ({ errors }) => {
  const columns = useErrorsListColumns(errors);

  useEffect(() => {
    if (!errors) return;
  }, [errors]);

  return (
    <Table
      rowKey='_id'
      tableLayout='auto'
      dataSource={errors}
      columns={columns}
      scroll={{ x: 'max-content' }}
      pagination={false}
    />
  );
};
